<a role="button"
   href=""
   class="td-wb-joyride-back-button"
   (click)="onClick()"
   [attr.aria-label]="'tdWb.core.joyride.step.BACK' | translate">
  <td-wb-icon iconId="caret-left--small"
              size="14"/>
  <ng-content/>
</a>
